// Governed commercial suite catalog for CRM "Suites of Interest".
// Stored values are canonical technical codes; labels are the commercial
// brand names (locale-invariant product names, identical in ES/EN).
export const CRM_SUITE_OPTIONS = [
  'talentmap', 'talentcheck', 'talentstart', 'talentheart', 'talentfix',
  'climara', 'talentcompetency', 'talenttrain', 'intelligence',
  'workforce_records', 'talentexit', 'global_ethics',
];

export const SUITE_COMMERCIAL_LABELS = {
  talentmap: 'TalentMap',
  talentcheck: 'TalentCheck',
  talentstart: 'TalentStart',
  talentheart: 'TalentHeart',
  talentfix: 'TalentFix',
  climara: 'Climara',
  talentcompetency: 'TalentCompetency',
  talenttrain: 'TalentTrain',
  intelligence: 'TalentIntelligence',
  workforce_records: 'Workforce Records',
  talentexit: 'TalentExit',
  global_ethics: 'Global Ethics',
};

export const suiteLabel = (code) => SUITE_COMMERCIAL_LABELS[code] || code;
